import styled from '@emotion/styled';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 240px 480px;
  min-height: 480px;
`;

export const Left = styled.div<{ index: number }>`
  position: relative;

  &::after {
    content: '';
    transition: all 0.2s ease;
    width: 2px;
    height: 61px;
    position: absolute;
    top: ${({ index }) => `${index * 61}px`};
    right: 0px;
    background-color: ${({ theme }) => theme.colors.shopl[400]};
  }
`;

export const Right = styled.div`
  padding: 26px 24px;
  width: 100%;
  height: 100%;
`;

export const Tabs = styled.ul<{ mode: string }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-right: 1px solid
    ${({ theme, mode }) => (mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : theme.colors.neutral[200])};
`;

export const Tab = styled.li<{ isSelected: boolean; mode: string }>`
  width: 100%;
  display: flex;
  height: 61px;
  transition: all 0.2s ease;
  opacity: ${({ isSelected }) => (isSelected ? '1' : '0.7')};
  align-items: flex-start;
  border-bottom: 1px solid
    ${({ theme, mode }) => (mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : theme.colors.neutral[200])};

  &:hover {
    opacity: 1;
  }
`;

export const TabBtn = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 18px 24px;
  display: flex;
  height: 60px;
  align-items: center;
  gap: 12px;
  background-color: transparent;
`;

export const TabBtnLabel = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;
